export const ManifestStatuses = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
};

export type ManifestStatusConfig = {
    label: string;
    color: string;
};

export type ManifestStatus = typeof ManifestStatuses[keyof typeof ManifestStatuses];

export const MANIFEST_STATUS_MAP: Record<ManifestStatus, ManifestStatusConfig> = {
    [ManifestStatuses.DRAFT]: { label: 'Draft', color: 'var(--gray-6)' },
    [ManifestStatuses.ACTIVE]: { label: 'Active', color: 'var(--polar-green-6)' },
    [ManifestStatuses.COMPLETED]: { label: 'Completed', color: 'var(--blue-6)' },
};
